import React from 'react';
import { motion } from 'framer-motion';
import { Github, Linkedin, Twitter, Mail, Coffee } from 'lucide-react';

const Footer = () => {
  const socialLinks = [
    { icon: Github, href: '//github.com/Bhushan791', label: 'GitHub' },
    { icon: Linkedin, href: 'https://www.linkedin.com/in/dev-bhushan-bhatta-a9bb4133b/', label: 'LinkedIn' },
    { icon: Twitter, href: '//x.com/Bhushan_Bhatta', label: 'Twitter' },
    { icon: Mail, href: 'mailto:bhushanbhatta777@gmail.com', label: 'Email' }
  ];

  return (
    <footer className="py-12 px-4 border-t border-primary-gold/20">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Copyright */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center md:text-left"
          >
            <p className="text-primary-muted text-sm">
              © 2025 Dev Bhushan Bhatta {' '} {' '}
  
              <Coffee className="inline text-yellow-500" size={14} />
            </p>
          </motion.div>

          {/* Social Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center gap-4"
          >
            {socialLinks.map((social, index) => (
              <motion.a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, y: -2 }}
                whileTap={{ scale: 0.95 }}
                className="w-10 h-10 bg-gradient-to-r from-primary-gold/10 to-primary-violet/10 rounded-full flex items-center justify-center border border-primary-gold/20 hover:border-primary-gold/40 transition-all duration-300 group"
              >
                <social.icon 
                  className="text-primary-gold group-hover:text-primary-text transition-colors duration-300" 
                  size={18} 
                />
              </motion.a>
            ))}
          </motion.div>
        </div>

        {/* Back to Top */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-8"
        >
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-primary-gold hover:text-primary-text transition-colors duration-300 text-sm font-medium"
          >
            Back to Top ↑
          </motion.button>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer; 